import { render, staticRenderFns } from "./foodorder.vue?vue&type=template&id=d741cc72&scoped=true"
import script from "./foodorder.vue?vue&type=script&lang=js"
export * from "./foodorder.vue?vue&type=script&lang=js"
import style0 from "./foodorder.vue?vue&type=style&index=0&id=d741cc72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d741cc72",
  null
  
)

export default component.exports